import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { Activatedmenu, Menu } from '../models/menu.model';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  //APP = 1 IS FOR ROOM EASE
  app: string = '1';

  /** Emits the built menu tree whenever it is ready (login or reload). */
  private menusSubject = new BehaviorSubject<any[]>(
    JSON.parse(localStorage.getItem('menus') || 'null') || []
  );
  menus$ = this.menusSubject.asObservable();

  /** Called by AppComponent after building rootMenus. */
  publishMenus(menus: any[]): void {
    this.menusSubject.next(menus);
  }
  
  private crmUrl = environment.crmTest;

  constructor(private http: HttpClient) {}

  fetchUsersActivatedMenus(userId: any){
    let url = this.crmUrl + '/user/'+userId+'/activatedmenu';
    return this.http.get<Menu[]>(url);
  }

   fetchUsersActivatedMenusinit(userId: any){
    let url = this.crmUrl + '/user/'+userId+'/activatedmenu/init?app=1';
    return this.http.get<Menu[]>(url);
  }
  
  fetchAllMenus(): Observable<Menu[]>{
    let url = this.crmUrl + '/menus/app/'+this.app;
    return this.http.get<Menu[]>(url);
  }

  fetchAllActivatedMenus(): Observable<Activatedmenu[]>{
    let url = this.crmUrl + '/menus/activatedmenu/app/'+this.app;
    return this.http.get<Activatedmenu[]>(url);
  }

  activateMenu(requestBody: any): Observable<any> {
    requestBody.app = {appId : this.app}
    let url = this.crmUrl + '/menus/activate';

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(url, requestBody, { headers });
  }

  desactivateMenu(requestBody: any): Observable<any> {
    requestBody.app = {appId : this.app}
    let url = this.crmUrl + '/menus/deactivate';
    
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(url, requestBody, { headers });
  }

  fetchAllUsersWithMenus(): Observable<Menu[]>{
    let url = this.crmUrl + '/user/activatedmenu';
    return this.http.get<Menu[]>(url);
  }

  fetchAllUsersWithMenusPage(page: any, size: any): Observable<any>{
    let params = new HttpParams();
    if (page != null && page != undefined) {
      params = params.set('page', page);
    }
    if (size != null && size != undefined) {
      params = params.set('size', size);
    }
    params = params.set('groupId', JSON.parse(localStorage.getItem('userDetails')).group.groupId);
    let url = this.crmUrl + '/user/activatedmenu/page';
    return this.http.get<Menu[]>(url, {params});
  }
  // https://crmapi.valeriahotels.com/api/user/123/menustat/2526539/true
  // changeUserMenuStat(menuStatId: any, activate: boolean): Observable<void>{
  //   let url = this.crmUrl + '/user/menustat/'+menuStatId+'/'+activate;
  //   return this.http.get<void>(url);
  // }

  changeUserMenuStat(userId: any, menuId: any, activate: boolean): Observable<void> {
    let url = `${this.crmUrl}/user/${userId}/menustat/${menuId}/${activate}`;
    return this.http.get<void>(url);
  }
}